<template lang="pug">
  main#main.manager-genders
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-venus-mars')
      section.l-section
        .l-section-h
          router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'manager-genders',
  components: {
    WcBreadcrumb,
  },
}
</script>
